import Machines from '../components/Machines'

const Equipment = () => {
  return (
    <section className='equipment' id='equipment'>
      <h2>Výrobní možnosti</h2>
      <h3>Technické zázemí společnosti</h3>
      <div className='equipment-info'>
        <span>Disponujeme rotačními CNC stroji,</span> se kterými obrábíme
        materiály od <span>Ø8 mm</span> do <span>Ø80 mm,</span> jsme schopni
        vyrábět z přířezu do <span>Ø250 mm,</span> obrábět výkovky nebo odlitky.
        Obrobíme tyčovinu různých materiálů, například{' '}
        <span>železo, nerez, dural, mosaz, silon</span> a další. Kromě běžných
        kalibrů a mikrometrů používáme i{' '}
        <span>
          profil-projektor JT12A-A, drsnoměr a nové optické měřící zařízení
          Keyence.
        </span>{' '}
        Můžeme <span>kooperovat</span> nebo zajistit výrobu včetně{' '}
        <span>
          materiálů, laserového značení, tepelného opracování, povrchových úprav
          a dopravy.
        </span>
      </div>
      <Machines />
    </section>
  )
}

export default Equipment
